<template>
    <div v-if="user">
        <div class="container-fluid overflow-hidden">
            <template v-if="$store.state.configs.subscription == 1">
                <div
                    v-if="user.plan && user.subscription && user.subscription.paused_at !== null"
                    class="alert alert-danger mb-3">
                    <b-icon-exclamation-triangle-fill/>
                    <span>{{ user.plan.common_name }}の決済が失敗しました。</span><!--
                 --><a href="/invoices" class="font-weight-bold" style="text-decoration: underline;">お支払い一覧</a><!--
                 --><span>からお支払いを完了してください。</span>
                </div>
            </template>

            <div class="row justify-content-center">
                <div class="col-12 col-lg-4 mb-4">
                    <div
                        v-if="user.plan && user.subscription"
                        class="mb-3">
                        <plan-info
                            :user="user"
                            cancelable>
                        </plan-info>
                    </div>

                    <user-consultation-next
                        :user="user"
                        :user-agent="userAgent">
                    </user-consultation-next>

                    <div
                        v-if="repeatConsultations === null"
                        class="d-flex justify-content-center align-items-center p-5">
                        <b-spinner variant="yokumiru-user"></b-spinner>
                    </div>
                    <div
                        v-else-if="repeatConsultations.length > 0"
                        class="card mt-3">
                        <div class="card-header">再度この内容で予約しませんか？</div>
                        <div class="card-body cardBodyRepeatDoctorMenus">
                            <div class="doctorMenusWrapper">
                                <div
                                    v-for="consultation in repeatConsultations"
                                    class="doctorMenu">
                                    <div
                                        v-if="!isRepeat(consultation)"
                                        class="btnCloseDoctorMenu"
                                        @click="onClickCloseDraft(consultation)">
                                        <span></span>
                                    </div>

                                    <template v-if="consultation.doctor_menu !== null">
                                        <doctor-menu-base-info
                                            :menu="consultation.doctor_menu"
                                            :user="user"
                                            :user-coupons="filteredUserCoupons"
                                            :with-repeatable-date="!!isRepeat(consultation)"
                                            :is-draft="!!isDraft(consultation)"
                                            :is-draft-by-doctor="!!isDraftByDoctor(consultation)">
                                        </doctor-menu-base-info>

                                        <hr class="divide">

                                        <doctor-info
                                            :doctor="consultation.doctor_menu.doctor"
                                            :user="user"
                                            :early-schedule="consultation.doctor_menu.early_schedule"
                                            is-display-repeat>
                                        </doctor-info>
                                    </template>
                                    <template v-else>
                                        <doctor-menu-base-info
                                            :menu="helper.matchingDoctorMenu(consultation.medical_course)"
                                            :user="user"
                                            :user-coupons="filteredUserCoupons"
                                            is-draft>
                                        </doctor-menu-base-info>
                                        <div class="descriptionWrapper descriptionWrapperExtended mt-1">
                                            <div class="description">{{ helper.matchingDoctorMenuDesc() }}</div>
                                        </div>
                                    </template>

                                    <b-button
                                        class="nextButton"
                                        @click="onClickRepeatDoctorMenu(consultation)">
                                        このメニューを予約する
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="$locale.type === 'consul'">
<!--                        <a-->
<!--                            v-if="isCampaign && !isUsedCampaignCouponCode"-->
<!--                            class="supportBanner"-->
<!--                            href="/user_coupons">-->
<!--                            <img src="images/common/kenko_banner2.png">-->
<!--                        </a>-->
<!--                        <div-->
<!--                            v-else-->
<!--                            class="supportBanner"-->
<!--                            @click="openModalSupport">-->
<!--                            <img src="images/common/banner__message.png">-->
<!--                        </div>-->
                        <div
                            class="supportBanner"
                            @click="openModalSupport">
                            <img src="images/common/banner__message.png">
                        </div>
                    </div>

                    <div
                        v-if="interviewTransQuestionMedicalCourses.length > 0 && canTransQuestion"
                        class="d-flex justify-content-center">
                        <b-button
                            @click="onClickBtnTransQuestion"
                            class="btnTransQuestion"
                            variant="yokumiru-user">
                            <div class="btnTransQuestionTitle">英語化問診票を作成する</div>
                            <div class="btnTransQuestionText">日本語で入力した内容を英語に自動翻訳してPDFでダウンロードすることができます</div>
                        </b-button>
                    </div>
                </div>

                <div class="col-12 col-lg-8 mb-4">
                    <div class="card">
                        <div class="card-header">予約する</div>
                        <div class="card-body">
                            <div
                                v-if="isCloseNotification.coupon === false && filteredUserCoupons.length > 0"
                                class="vc-notification d-flex justify-content-between align-items-center">
                                <div>
                                    <span class="vc-notification__text">現在お使いいただけるクーポンがあります。</span>
                                    <b-button
                                        class="vc-notification__btn"
                                        size="sm"
                                        variant="yokumiru-ash"
                                        href="/user_coupons">
                                        確認する
                                    </b-button>
                                </div>
                                <div
                                    class="vc-notification__close"
                                    @click="isCloseNotification.coupon = true">
                                    <span>&times;</span>
                                </div>
                            </div>
                            <div
                                v-if="user.is_device_timezone != 1 && isCloseNotification.timezone === false && !isMatchTimezone"
                                class="vc-notification vc-notification--danger d-flex justify-content-between align-items-center">
                                <div>
                                    <span class="vc-notification__text text-danger">
                                        <b-icon-exclamation-triangle-fill/>{{ $locale.appName }}に設定中のタイムゾーンと、デバイスのタイムゾーンが異なるようです。
                                    </span>
                                    <b-button
                                        class="vc-notification__btn"
                                        size="sm"
                                        variant="yokumiru-ash"
                                        href="/profile">
                                        確認する
                                    </b-button>
                                </div>
                                <div
                                    class="vc-notification__close"
                                    @click="isCloseNotification.timezone = true">
                                    <span>&times;</span>
                                </div>
                            </div>

                            <div
                                v-if="medicalCourses === null"
                                class="d-flex justify-content-center align-items-center p-5">
                                <b-spinner variant="yokumiru-user"></b-spinner>
                            </div>
                            <div v-else>
                                <template v-if="$locale.type === 'consul'">
                                    <h3 class="reservationMedicalCourseListItemTitle">
                                        ご利用の多い{{ $locale.consultation_host }}科（一般{{ $locale.consultation_host }}科）
                                    </h3>
                                    <div class="reservationMedicalCourseListItemWrapper d-flex flex-wrap align-items-stretch">
                                        <div
                                            v-if="medicalCourseHowTo !== null && medicalCourseHowTo !== void(0)"
                                            class="reservationMedicalCourseListItem reservationMedicalCourseListItemAsImage d-flex align-items-center"
                                            @click="openModalReservationDoctorMenus(medicalCourseHowTo)">
                                            <img src="images/common/banner__support.png">
                                        </div>
                                        <div
                                            v-if="canHealthSurvey"
                                            class="reservationMedicalCourseListItem reservationMedicalCourseListItemAsImage d-flex align-items-center">
                                            <a href="/health_surveys"><img src="images/common/banner_health_survey.png"></a>
                                        </div>
                                        <div
                                            v-for="(medicalCourse, index) in commonMedicalCourses"
                                            class="reservationMedicalCourseListItem d-flex align-items-center"
                                            @click="openModalReservationDoctorMenus(medicalCourse)">
                                            <div class="reservationMedicalCourseListItemDoctorImageWrapper">
                                                <div class="reservationMedicalCourseListItemDoctorImage">
                                                    <img :src="medicalCourseImage(medicalCourse)">
                                                </div>
                                                <div class="reservationMedicalCourseListItemDoctorCount">
                                                    {{ medicalCourse.doctor_count }}人の医師
                                                </div>
                                            </div>
                                            <div class="reservationMedicalCourseListItemText">
                                                <div class="reservationMedicalCourseName">
                                                    {{ medicalCourse.name }}
                                                </div>
                                                <div
                                                    v-if="medicalCourse.is_health_package"
                                                    class="reservationMedicalCourseHealthPackageIcon">
                                                    <img src="/images/common/label_health_package2.png">
                                                </div>
                                                <div
                                                    v-if="medicalCourse.description !== null"
                                                    class="small text-muted reservationMedicalCourseDescription">
                                                    {{ medicalCourse.description }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <template v-if="medicalCourses['specialty'].length > 0">
                                        <h3 class="reservationMedicalCourseListItemTitle">専門的な{{ $locale.consultation_host }}をしたい方（専門{{ $locale.consultation_host }}科）</h3>
                                        <div class="reservationMedicalCourseListItemWrapper reservationMedicalCourseListItemWrapperSpecialty d-flex flex-wrap align-items-stretch">
                                            <div
                                                v-for="medicalCourse in medicalCourses['specialty']"
                                                @click="openModalReservationDoctorMenus(medicalCourse)"
                                                class="reservationMedicalCourseListItem reservationMedicalCourseListItemSpecialty d-flex align-items-center">
                                                <div class="reservationMedicalCourseListItemDoctorImageWrapper">
                                                    <div class="reservationMedicalCourseListItemDoctorImage">
                                                        <img :src="medicalCourseImage(medicalCourse)">
                                                    </div>
                                                </div>
                                                <div class="reservationMedicalCourseListItemText">
                                                    <div class="reservationMedicalCourseName">
                                                        {{ medicalCourse.name }}
                                                    </div>
                                                    <div
                                                        v-if="medicalCourse.is_health_package"
                                                        class="reservationMedicalCourseHealthPackageIcon">
                                                        <img src="/images/common/label_health_package2.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <p class="reservationMedicalCourseText mt-3 mb-2">
                                        予約する{{ $locale.consultation_host }}科を選択してください。
                                    </p>
                                    <div class="reservationMedicalCourseListItemWrapper d-flex flex-wrap align-items-stretch">
                                        <div
                                            v-for="medicalCourse in medicalCourses"
                                            @click="openModalReservationDoctorMenus(medicalCourse)"
                                            class="reservationMedicalCourseListItem d-flex align-items-center">
                                            <div class="reservationMedicalCourseListItemDoctorImageWrapper">
                                                <div class="reservationMedicalCourseListItemDoctorImage">
                                                    <img :src="medicalCourseImage(medicalCourse)">
                                                </div>
                                                <div class="reservationMedicalCourseListItemDoctorCount">
                                                    {{ medicalCourse.doctor_count }}人の医師
                                                </div>
                                            </div>
                                            <div class="reservationMedicalCourseListItemText">
                                                <div class="reservationMedicalCourseName">
                                                    {{ medicalCourse.name }}
                                                </div>
                                                <div
                                                    v-if="medicalCourse.is_health_package"
                                                    class="reservationMedicalCourseHealthPackageIcon">
                                                    <img src="/images/common/label_health_package2.png">
                                                </div>
                                                <div
                                                    v-if="medicalCourse.description !== null"
                                                    class="small text-muted reservationMedicalCourseDescription">
                                                    {{ medicalCourse.description }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div id="dashboardUserConsultations">
                        <user-consultations :user="user"/>
                    </div>
                </div>
            </div>
        </div>

        <doctor-profile-modal :user="user"/>
        <user-support-modal :user="user" :env="env"/>
        <how-to-use-coupon-modal/>

        <subscription-cancel-modal/>
        <subscription-file-upload-modal/>

        <reservation-doctor-menus-modal :is-campaign="isCampaign"/>
        <reservation-doctor-menu-detail-modal/>
        <reservation-interview-modal/>
        <reservation-rest-time :timezone="user.timezone"/>

        <page-transition-modal
            ok-text="詳細を確認"
            cancel-text="閉じる"
            :ok-hidden="!isUserAuthorizerOrganization && !isUserAuthorizerCompany"
            :link="authorizerUrl">
        </page-transition-modal>

        <reservation-payment-method-modal
            :data-pubkey="pubkey"
            :payment-methods="paymentMethods">
        </reservation-payment-method-modal>

        <user-coupon-code-modal/>

        <reservation-confirm-modal
            :data-pubkey="pubkey"
            :user-agent="userAgent">
        </reservation-confirm-modal>

        <reservation-cancel-modal
            :user="user">
        </reservation-cancel-modal>

        <user-coupons-notification-modal
            :user="user"
            :user-coupons="newUserCoupons">
        </user-coupons-notification-modal>

        <user-interview-trans-question-medical-courses-modal
            :user="user"
            :medical-courses="interviewTransQuestionMedicalCourses">
        </user-interview-trans-question-medical-courses-modal>

        <user-interview-trans-questions-modal/>
        <user-interview-trans-questions-confirm-modal/>
        <user-interview-trans-answers-modal/>
        <user-interview-trans-modification-modal/>
        <user-interview-trans-completed-modal/>

        <user-draft-consultation-confirm-modal
            :user="user"
            :stripe-pubkey="pubkey">
        </user-draft-consultation-confirm-modal>

        <user-draft-delete-modal :user="user"/>
    </div>
</template>

<script>
    import constants from '../../constants'
    import YokumiruHelper from '../../YokumiruHelper'
    import { mapMutations } from 'vuex'
    import moment from 'moment-timezone'

    export default {
        name: 'UserDashboard',

        props: {
            paymentMethods: {
                type: Array,
                required: true,
            },
            pubkey: {
                type: String,
                required: true,
            },
            setup: {
                type: String,
                default: '',
            },
            userAgent: {
                type: String,
                default: 'web',
            },
            env: {
                type: String,
                required: true,
            },
            campaignStart: {
                type: String,
                default: null,
            },
            campaignEnd: {
                type: String,
                default: null,
            },
            campaignCouponCodeId: {
                type: String,
                default: null,
            },
            transQuestionGroupIds: {
                type: Array,
                default: [],
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                user: null,
                newUserCoupons: [],
                medicalCourses: null,
                interviewTransQuestionMedicalCourses: [],
                repeatConsultations: [],
                isCloseNotification: {
                    coupon: false,
                    timezone: false,
                },
                consultationsCount: null,
            }
        },

        computed: {
            /**
             * 特定のグループに所属する会員に対してのみ英語化問診票バナーを表示する
             * @see https://github.com/sewii/Yokumiru/issues/850
             * @return {boolean}
             */
            canTransQuestion: function () {
                if (!this.user) return false

                // グループの指定が無い場合はすべての会員に表示する
                if (this.transQuestionGroupIds.length < 1) {
                    return true
                }

                return this.user.groups.some((group) => {
                    return this.transQuestionGroupIds.includes(group.id)
                })
            },

            /**
             * キャンペーン期間中かどうか判定
             * @return {boolean}
             */
            isCampaign: function () {
                if (!this.campaignStart || !this.campaignEnd) {
                    return false
                }

                const now = moment()
                const start = moment(this.campaignStart)
                const end = moment(this.campaignEnd)

                return now.isSameOrAfter(start) && now.isSameOrBefore(end)
            },

            /**
             * キャンペーン用のクーポンコードを使用済みかどうか判定
             * @return {boolean}
             */
            isUsedCampaignCouponCode: function () {
                // CAMPAIGN_COUPON_CODE_ID が未設定の場合はtrueとみなす
                if (!this.user || !this.campaignCouponCodeId) {
                    return true
                }

                return this.user.used_coupon_code_ids.includes(Number(this.campaignCouponCodeId))
            },

            /**
             * デバイスのタイムゾーンを取得
             * @returns {string}
             */
            deviceTimezone: function () {
                return moment.tz.guess()
            },

            /**
             * デバイスのタイムゾーンと会員のタイムゾーン設定が合致しているかどうか
             * @returns {boolean}
             */
            isMatchTimezone: function () {
                if (!this.user) return true
                return this.deviceTimezone === this.user.timezone
            },

            /**
             * 所属法人
             * @return {null|object}
             */
            userCompany: function () {
                return this.helper.userCompany(this.user)
            },

            /**
             * 法人会員で利用停止中かどうか
             * @return {boolean}
             */
            isUserPausedCompany: function () {
                return this.userCompany && this.userCompany.flg_paused
            },

            /**
             * 法人の担当者かどうか
             * @return {boolean}
             */
            isUserAuthorizerCompany: function () {
                if (!this.user) return false
                return this.userCompany && this.userCompany.authorizer_id === this.user.id
            },

            /**
             * メンタルチェックを利用するかどうか
             * @return {boolean}
             */
            canHealthSurvey: function () {
                return this.userCompany
                    && this.userCompany.metadata
                    && this.userCompany.metadata.is_health_survey
            },

            /**
             * 所属団体
             * @return {null|object}
             */
            userOrganization: function () {
                return this.helper.userOrganization(this.user)
            },

            /**
             * 団体会員で利用停止中かどうか
             * @return {boolean}
             */
            isUserPausedOrganization: function () {
                return this.userOrganization && this.userOrganization.flg_paused
            },

            /**
             * 団体の担当者かどうか
             * @return {boolean}
             */
            isUserAuthorizerOrganization: function () {
                if (!this.user) return false
                return this.userOrganization && this.userOrganization.authorizer_id === this.user.id
            },

            /**
             * 担当者画面のURL
             * @return {string}
             */
            authorizerUrl: function () {
                if (this.userCompany) return '/company'
                if (this.userOrganization) return '/organization'
                return '/invoices'
            },

            /**
             * 所持クーポンのフィルタリング
             * （相談予約カテゴリのクーポンだけにする）
             * @return {array}
             */
            filteredUserCoupons: function () {
                return this.helper.filteredUserCoupons(this.user)
            },

            /**
             * 一般相談科のリスト（無料使い方相談を除外）
             * @return {array}
             */
            commonMedicalCourses: function () {
                if (this.medicalCourses === null) return []
                return this.medicalCourses.common.filter((course) => !course.name.includes('無料使い方'))
            },

            /**
             * 無料使い方相談の相談科
             * @return {object}
             */
            medicalCourseHowTo: function () {
                if (this.medicalCourses === null) return null
                return this.medicalCourses.common.find((course) => course.name.includes('無料使い方'))
            },
        },

        created: function () {
            // 画面読み込み時は予約関連のstateをクリア
            this.clearReservation()

            bus.$on('timezone-updated', this.fetchMe)
            bus.$on('user-reservation-completed', this.fetchMe)
            bus.$on('credit-card-stored', this.onCreditCardStored)
            bus.$on('on-click-how-to-consultation', this.openHowToConsultationMenuDetail)
            bus.$on('user-consultations-fetched', this.setConsultationsCount)
            bus.$on('user-draft-deleted', this.fetchRepeatConsultations)
            bus.$on('user-draft-reservation-accepted', () => {
                this.fetchRepeatConsultations()
                bus.$emit('alert-success', `${this.$locale.consultation_host}予約が完了しました`)
            })
        },

        beforeDestroy: function () {
            bus.$off('timezone-updated')
            bus.$off('user-reservation-completed')
            bus.$off('credit-card-stored')
            bus.$off('on-click-how-to-consultation')
            bus.$off('user-consultations-fetched')
            bus.$off('user-draft-reservation-accepted')
            bus.$off('user-draft-deleted')
        },

        mounted: async function () {
            this.handleLoginRedirect()

            await this.fetchMe()
            this.fetchNewUserCoupons()
            this.fetchMedicalCourses()
            this.fetchRepeatConsultations()
            this.fetchInterviewTransQuestionMedicalCourses()

            this.setMode('default')
            await this.handleDeeplink()

            if (this.$store.state.userMode.redirectMessage && this.$store.state.userMode.redirectMessageType) {
                const message = this.$store.state.userMode.redirectMessage
                const type = this.$store.state.userMode.redirectMessageType
                bus.$emit(`alert-${type}`, message)
                this.setRedirectMessage(null)
                this.setRedirectMessageType(null)
            }
            // @todo 以降のアラートは redirectMessage に置き換える
            else if (this.$store.state.userMode.isSubscriptionStarted) {
                // サブスクリプション開始後アラート
                bus.$emit('alert-info', `${this.user.plan.common_name}をご利用いただけます。`)
            }
            else if (this.$store.state.userMode.isResetPassword) {
                // 初回ログイン時のパスワード更新後アラート
                bus.$emit('alert-info', '初回ログイン設定が完了しました。')
            }
            else if (this.$store.state.userMode.isAgreedTerms || this.$store.state.userMode.isAgreedPrivacy) {
                // 規約同意
                const isAgreedTerms = this.$store.state.userMode.isAgreedTerms
                const isAgreedPrivacy = this.$store.state.userMode.isAgreedPrivacy

                let format = ''
                if (isAgreedTerms && isAgreedPrivacy) {
                    format = '利用規約・プライバシーポリシー'
                }
                else if (isAgreedTerms) {
                    format = '利用規約'
                }
                else if (isAgreedPrivacy) {
                    format = 'プライバシーポリシー'
                }
                bus.$emit('alert-info', `${format}に同意しました。`)
            }
            else if (this.$store.state.userMode.isAgreedTermsPlan) {
                bus.$emit('alert-info', `${this.user.plan.name}利用特約に同意しました。`)
            }

            // stateのリセット
            this.setIsSubscriptionStarted(false)
            this.setIsResetPassword(false)
            this.setIsAgreedTerms(false)
            this.setIsAgreedPrivacy(false)
            this.setIsAgreedTermsPlan(false)
        },

        methods: {
            ...mapMutations({
                setRedirectMessage: 'userMode/setRedirectMessage',
                setRedirectMessageType: 'userMode/setRedirectMessageType',
                setPreviousDeeplink: 'userMode/setPreviousDeeplink',
                setIsAgreedTerms: 'userMode/setIsAgreedTerms',
                setIsAgreedPrivacy: 'userMode/setIsAgreedPrivacy',
                setIsAgreedTermsPlan: 'userMode/setIsAgreedTermsPlan',
                setIsResetPassword: 'userMode/setIsResetPassword',
                setIsSubscriptionStarted: 'userMode/setIsSubscriptionStarted',
                setMode: 'reservation/setMode',
                setUser: 'reservation/setUser',
                setMedicalCourse: 'reservation/setMedicalCourse',
                setDoctorMenu: 'reservation/setDoctorMenu',
                setSchedule: 'reservation/setSchedule',
                setPrevConsultation: 'reservation/setPrevConsultation',
                setAsRepeat: 'reservation/setAsRepeat',
                clearReservation: 'reservation/clearReservation',
            }),

            /**
             * 未ログインの状態でディープリンクを踏み、その後ログインした場合のリダイレクトハンドリング
             * @see resources/js/components/user/UserDeeplinkHandle.vue
             */
            handleLoginRedirect: function () {
                if (this.$store.state.userMode.previousDeeplink) {
                    const link = this.$store.state.userMode.previousDeeplink
                    this.setPreviousDeeplink(null)
                    window.location.href = link
                }
            },

            /**
             * ディープリンクのハンドリング
             * @see https://github.com/sewii/yokumiru_mobile/issues/395
             */
            handleDeeplink: async function () {
                if (this.$route.query.action === 'reservation_doctor') {
                    const doctorId = Number(this.$route.query.doctor_id)
                    if (doctorId > 0) {
                        bus.$emit('open-modal-doctor-profile', doctorId, { canReserve: true })
                    }
                }
                else if (this.$route.query.action === 'reservation_menu') {
                    let medicalCourse = this.medicalCourses.common.find((course) => course.id === Number(this.$route.query.medical_course_id))
                    if (!medicalCourse) {
                        medicalCourse = this.medicalCourses.specialty.find((course) => course.id === Number(this.$route.query.medical_course_id))
                    }
                    if (medicalCourse) {
                        this.openModalReservationDoctorMenus(medicalCourse)
                    }
                }
                else if (this.$route.query.action === 'reservation_menu_detail') {
                    let medicalCourse = this.medicalCourses.common.find((course) => course.id === Number(this.$route.query.medical_course_id))
                    if (!medicalCourse) {
                        medicalCourse = this.medicalCourses.specialty.find((course) => course.id === Number(this.$route.query.medical_course_id))
                    }
                    const doctorMenuId = Number(this.$route.query.doctor_menu_id)
                    const doctorMenu = await this.fetchDoctorMenu(doctorMenuId)

                    if (medicalCourse && doctorMenu && medicalCourse.id === doctorMenu.medical_course_id) {
                        this.openModalReservationDoctorMenus(medicalCourse)
                        this.openModalReservationDoctorMenuDetail(medicalCourse, doctorMenu)
                    }
                }
            },

            /**
             * 医師メニュー取得
             *
             * @param doctorMenuId
             */
            fetchDoctorMenu: function (doctorMenuId) {
                return axios.get(`${constants.user.doctor_menus.endpoint.base}/${doctorMenuId}`)
                    .then(({data}) => {
                        return data.data
                    })
            },

            /**
             * 無料使い方相談の医師メニュー取得
             */
            fetchHowToUseDoctorMenu: function () {
                return axios.get(`${constants.user.doctor_menus.endpoint.base}/how`)
                    .then(({data}) => {
                        return data.data
                    })
            },

            /**
             * 優先度が一番高い医師を返す
             *
             * @param {array} doctors
             * @return {object}
             */
            primalDoctor: function (doctors) {
                if (doctors.length < 1) {
                    return null
                }

                const doctor = doctors.reduce((d1, d2) => d1.priority_num > d2.priority_num ? d1 : d2, 0)
                return doctor.priority_num === 1 ? doctors[0] : doctor
            },

            /**
             * 相談科に設定された画像を返却
             * @return {string}
             */
            medicalCourseImage: function (medicalCourse) {
                return medicalCourse.icon_url ? medicalCourse.icon_url : '/images/common/sodanka-common.png'
            },

            /**
             * 相談科一覧を取得
             */
            fetchMedicalCourses: function () {
                const endpoint = constants.user.medical_courses.endpoint.base
                const query = this.$locale.type === 'consul' ? '?is_grouped=1' : ''

                return axios.get(`${endpoint}${query}`)
                    .then(({data}) => {
                        this.medicalCourses = data.data
                    })
            },

            /**
             * 英語科問診用の相談科一覧を取得
             */
            fetchInterviewTransQuestionMedicalCourses: function () {
                const endpoint = constants.user.interview_trans_questions.endpoint.base

                return axios.get(`${endpoint}/medical_courses`)
                    .then(({data}) => {
                        this.interviewTransQuestionMedicalCourses = data.data
                    })
            },

            /**
             * 再相談メニュー一覧を取得
             */
            fetchRepeatConsultations: function () {
                if (this.$locale.type !== 'consul') return

                this.repeatConsultations = null
                const endpoint = constants.user.consultations.endpoint.base

                return axios.get(`${endpoint}/repeat`)
                    .then(({data}) => {
                        // @see https://github.com/sewii/Yokumiru/issues/977
                        this.repeatConsultations = data.data.sort((a, b) => {
                            let aDiscount
                            let bDiscount

                            if (a.is_matching_reserved) {
                                aDiscount = this.helper.maxMatchingDiscountCoupon(this.filteredUserCoupons, this.user, a.medical_course)?.discount || 0
                            } else {
                                aDiscount = this.helper.maxDiscountCoupon(this.filteredUserCoupons, a.doctor_menu)?.discount || 0
                            }

                            if (b.is_matching_reserved) {
                                bDiscount = this.helper.maxMatchingDiscountCoupon(this.filteredUserCoupons, this.user, b.medical_course)?.discount || 0
                            } else {
                                bDiscount = this.helper.maxDiscountCoupon(this.filteredUserCoupons, b.doctor_menu)?.discount || 0
                            }

                            if (aDiscount < bDiscount) return 1
                            if (aDiscount > bDiscount) return -1
                            return 0
                        })
                    })
            },

            /**
             * ログインユーザ取得
             */
            fetchMe: function () {
                return axios.get(constants.user.me.endpoint.base)
                    .then(({data}) => {
                        this.user = data.data
                    })
            },

            /**
             * 新規取得クーポン一覧
             */
            fetchNewUserCoupons: function () {
                return axios.get(constants.user.me.endpoint.new_user_coupons)
                    .then(({data}) => {
                        this.newUserCoupons = data.data
                        if (this.newUserCoupons && this.newUserCoupons.length > 0 ) {
                            bus.$emit('open-modal-user-coupons-notification')
                        }
                    })
            },

            /**
             * 再相談メニュー選択時
             * @param {object} consultation
             */
            onClickRepeatDoctorMenu: async function (consultation) {
                if (this.isDraftByDoctor(consultation)) {
                    bus.$emit('open-modal-user-draft-consultation-confirm', consultation)
                }
                else {
                    await this.openModalReservationDoctorMenus(consultation.medical_course, consultation)
                    this.openModalReservationDoctorMenuDetail(consultation.medical_course, consultation.doctor_menu, consultation)
                }
            },

            /**
             * 再予約メニューの × ボタン押下時
             * @param {object} consultation
             */
            onClickCloseDraft: function (consultation) {
                bus.$emit('open-modal-user-draft-delete', consultation)
            },

            /**
             * クレジットカード登録時
             */
            onCreditCardStored: function () {
                this.user.has_payment_method = true
            },

            /**
             * 予約フロー判定
             * @return {boolean}
             */
            validateOpenModal: function () {
                if (this.isUserPausedOrganization) {
                    bus.$emit(
                        'open-modal-page-transition',
                        '予約できません',
                        '会員様の団体は現在利用停止中です。'
                    )
                    return false
                }
                else if (this.isUserPausedCompany) {
                    bus.$emit(
                        'open-modal-page-transition',
                        '予約できません',
                        '会員様の法人は現在利用停止中です。'
                    )
                    return false
                }

                if (this.$store.state.configs.subscription == 1 && this.user.subscription) {
                    if (this.user.subscription.paused_at !== null) {
                        bus.$emit(
                            'open-modal-page-transition',
                            '予約できません',
                            'お支払いを完了してから予約を行ってください。'
                        )
                        return false
                    }

                    if (
                        !this.helper.hasSubscription(this.user, true, [constants.subscriptions.canceled]) &&
                        !medicalCourse.name.includes('無料使い方')
                    ) {
                        bus.$emit(
                            'open-modal-page-transition',
                            '予約できません',
                            'ご利用期間外のプランです。'
                        )
                        return false
                    }

                    if (this.user.plan.is_upload_document && !this.user.subscription.review.document_url) {
                        bus.$emit(
                            'open-modal-page-transition',
                            '予約できません',
                            '書類のアップロード後に予約してください。'
                        )
                        return false
                    }
                }
                return true
            },

            /**
             * メニュー選択モーダル表示
             * @param {object} medicalCourse
             * @param {object} consultation
             */
            openModalReservationDoctorMenus: async function (medicalCourse, consultation = null) {
                if (!this.validateOpenModal()) return

                this.pushAnalyticsDataLayerSelectMedicalCourse(medicalCourse)

                // 以前と異なる相談科が選択されたら問診内容をクリア
                const prevMedicalCourse = this.$store.state.reservation.medicalCourse
                if (!prevMedicalCourse || prevMedicalCourse.id !== medicalCourse.id) {
                    bus.$emit('clear-reservation-interview-questions')
                }

                this.setUser(this.user)
                this.setMedicalCourse(medicalCourse)
                this.setPrevConsultation(consultation)
                bus.$emit('open-modal-reservation-doctor-menus')
            },

            /**
             * メニュー詳細モーダル表示
             * @param {object} medicalCourse
             * @param {object} doctorMenu
             * @param {object} consultation
             */
            openModalReservationDoctorMenuDetail: function (medicalCourse, doctorMenu, consultation = null) {
                if (!this.validateOpenModal()) return

                if (doctorMenu) {
                    this.pushAnalyticsDataLayerSelectDoctorMenu(doctorMenu)

                    // 以前と異なるメニューが選択されたら問診内容をクリア
                    const currentMenu = this.$store.state.reservation.doctorMenu
                    if (!currentMenu || doctorMenu.id !== currentMenu.id) {
                        bus.$emit('clear-reservation-interview-questions')
                    }

                    const asRepeat = this.helper.isRepeatable(
                        doctorMenu,
                        this.$store.state.userConsultations.recentlyConsultations,
                        this.user.timezone
                    )
                    this.setMode('default')
                    this.setAsRepeat(asRepeat)
                    this.setDoctorMenu(doctorMenu)
                    this.setMedicalCourse(medicalCourse)
                    this.setPrevConsultation(consultation)
                    this.setUser(this.user)
                }
                else {
                    // マッチング予約
                    this.pushAnalyticsDataLayerSelectDoctorMenuMatching()
                    bus.$emit('clear-reservation-interview-questions')
                    this.setMode('matching')
                    this.setAsRepeat(false)
                    this.setDoctorMenu(null)
                    this.setMedicalCourse(medicalCourse)
                    this.setPrevConsultation(consultation)
                    this.setUser(this.user)
                }

                bus.$emit('open-modal-reservation-doctor-menu-detail')
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             * @param {object} medicalCourse
             */
            pushAnalyticsDataLayerSelectMedicalCourse: function (medicalCourse) {
                if (this.$locale.type !== 'consul') return

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__selectMedicalCourse',
                    medicalCourseName: medicalCourse.name,
                })
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             * @param {object} doctorMenu
             */
            pushAnalyticsDataLayerSelectDoctorMenu: function (doctorMenu) {
                if (this.$locale.type !== 'consul') return

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__selectDoctorMenu',
                    doctorMenuId: doctorMenu.id,
                    doctorMenuTitle: doctorMenu.title,
                })
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             */
            pushAnalyticsDataLayerSelectDoctorMenuMatching: function () {
                if (this.$locale.type !== 'consul') return

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__selectDoctorMenu',
                    doctorMenuId: null,
                    doctorMenuTitle: '日付から予約',
                })
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             * @param {object} consultation
             */
            pushAnalyticsDataLayerSelectScheduleTime: function (consultation) {
                if (this.$locale.type !== 'consul') return

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__selectScheduleTime',
                    startTime: consultation.start_time,
                    endTime: consultation.end_time,
                    doctorMenuId: consultation.doctor_menu.id,
                    doctorMenuTitle: consultation.doctor_menu.title,
                })
            },

            /**
             * サポートモーダル表示
             */
            openModalSupport: function () {
                this.pushAnalyticsDataLayerModalSupport()
                bus.$emit('open-modal-user-support')
            },

            /**
             * GoogleAnalytics GA4 カスタムイベント発火
             */
            pushAnalyticsDataLayerModalSupport: function () {
                if (this.$locale.type !== 'consul') return

                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event: 'dl__clickSupportBanner',
                })
            },

            /**
             * 使い方相談のメニュー詳細を表示
             */
            openHowToConsultationMenuDetail: async function () {
                const doctorMenu = await this.fetchHowToUseDoctorMenu()
                this.openModalReservationDoctorMenus(doctorMenu.medical_course)
            },

            /**
             * 予約リストの件数をセット
             *
             * @param {number} count
             */
            setConsultationsCount: function (count) {
                this.consultationsCount = count
            },

            /**
             * 英語化問診票の作成ボタン押下時
             */
            onClickBtnTransQuestion: function () {
                bus.$emit('open-modal-user-interview-trans-question-medical-courses')
            },

            /**
             * 再相談card判定: 再相談可能な予約
             * @param {object} consultation
             */
            isRepeat: function (consultation) {
                return consultation.doctor_menu
                    && consultation.doctor_menu.is_repeatable
                    && ! consultation.is_draft
            },

            /**
             * 再相談card判定: ドラフト予約
             * @param {object} consultation
             */
            isDraft: function (consultation) {
                return consultation.is_draft && consultation.flg_cancel
            },

            /**
             * 再相談card判定: 医師によるドラフト予約
             * @param {object} consultation
             */
            isDraftByDoctor: function (consultation) {
                return consultation.is_draft && ! consultation.flg_cancel
            },
        },
    }
</script>

<style scoped lang="scss">
.cardBodyRepeatDoctorMenus {
    padding: 1rem;
    background-color: #FCFCE7;

    .doctorMenusWrapper {
        height: 500px;
        overflow: hidden;
        overflow-y: auto;

        @media screen and (max-width: 991px) {
            .doctorMenusWrapper {
                width: 100%;
            }
        }

        .doctorMenu {
            position: relative;
            vertical-align: top;
            width: 100%;
            margin-bottom: 10px;
            padding: 20px 25px;
            background-color: #f9f9f9;
            border: 1px solid #dee2e6;
            border-radius: 6px;

            @media screen and (max-width: 1280px) {
                max-width: 100%;
            }
        }

        .nextButton {
            display: block;
            width: 210px;
            height: 34px;
            line-height: 34px;
            padding: 0;
            margin: 25px auto 0;
            color: #fff;
            font-weight: bold;
            text-align: center;
            background-color: #CF798A;
            border: none;
            border-radius: 25px;
            cursor: pointer;

            transition: background-color 0.3s ease-in-out;

            &:hover {
                background-color: #bd6071;
            }
        }
    }
}

.btnCloseDoctorMenu {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;

    > span {
        display: inline-block;
        vertical-align: middle;
        color: #62625E;
        line-height: 1;
        width: 25px;
        height: 2.5px;
        background: currentColor;
        border-radius: 4px;
        position: relative;
        transform: rotate(45deg);

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: inherit;
            border-radius: inherit;
            transform: rotate(90deg);
        }
    }
}

.divide {
    border-top: 1px dotted #ABB3BA;
}

.vc-notification {
    margin-bottom: 12px;
    padding: 9px 10px;
    border: 2px solid #86ccda;
    border-radius: 5px;

    .vc-notification__text {
        font-size: .875rem;

        svg {
            margin-right: 4px;
            fill: #f79e08;
        }
    }

    .vc-notification__btn {
        padding: 2px 6px;
        font-size: .75rem;
    }

    .vc-notification__close {
        position: relative;
        width: 20px;
        height: 20px;
        min-width: 20px;
        color: #fff;
        line-height: 19px;
        font-weight: bold;
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
        background: #86CCDA;
    }

    &.vc-notification--danger {
        border: 2px solid #dc3545;

        .vc-notification__close {
            background: #DC3545;
        }
    }
}

.reservationMedicalCourseListItemTitle {
    margin-top: 15px;
    color: #7D868D;
    font-size: 18px;
    font-weight: bold;
}

.reservationMedicalCourseText {
    color: #7D868D;
    font-size: 14px;
}

.reservationMedicalCourseListItemWrapper {
    width: 100%;
    margin: 10px 0 35px;

    &.reservationMedicalCourseListItemWrapperSpecialty {
        margin: 15px 0 15px;
    }
}

.reservationMedicalCourseListItem {
    position: relative;
    width: calc(50% - 10px);
    margin: 5px;
    padding: 16px 40px 16px 20px;
    
    border-radius: 6px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    box-sizing: border-box;
    transition: opacity 0.3s ease-in-out;
    border: solid 3px rgb(100	179	238	);

    @media screen and (max-width: 767px) {
        display: block;
        width: calc(100% - 10px);
    }

    &:hover {
        opacity: 0.7;
    }

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 20px;
        width: 8px;
        height: 8px;
        margin-top: -5px;
        border-top: solid 1px #9D9D9D;
        border-right: solid 1px #9D9D9D;
        transform: rotate(45deg);
    }

    &.reservationMedicalCourseListItemAsImage {
        width: 442px;
        padding: 0;
        margin: 0 auto 10px;
        background-color: transparent;
        border: none;

        @media screen and (max-width: 1440px) {
            width: 400px;
        }

        @media screen and (max-width: 1320px) {
            width: 360px;
        }

        @media screen and (max-width: 1200px) {
            width: 320px;
        }

        @media screen and (max-width: 1080px) {
            width: 280px;
        }

        @media screen and (max-width: 991px) {
            width: 330px;
        }

        @media screen and (max-width: 740px) {
            width: 300px;
        }

        @media screen and (max-width: 680px) {
            width: 442px;
        }

        img {
            width: 98%;

            @media screen and (max-width: 560px) {
                width: 100%;
            }
        }

        &::after {
            display: none;
        }
    }

    &.reservationMedicalCourseListItemSpecialty {
        width: calc(25% - 10px);
        padding: 10px 20px 10px 10px;

        @media screen and (max-width: 1299px) {
            width: calc(33% - 10px);
        }

        @media screen and (max-width: 767px) {
            display: block;
            width: calc(50% - 10px);
        }

        .reservationMedicalCourseListItemDoctorImage {
            position: static;
            top: auto;
            overflow: hidden;
            width: 32px;
            min-width: 32px;
            height: 32px;
            border-radius: 50%;

            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }

        .reservationMedicalCourseListItemText {
            width: calc(100% - 32px);
            overflow: hidden;
            margin-left: 10px;

            .reservationMedicalCourseName {
                margin: 0 10px 0 0;
                font-size: 14px;
            }
        }
    }
}

.reservationMedicalCourseListItemDoctorImageWrapper {
    position: relative;
}

.reservationMedicalCourseListItemDoctorCount {
    position: absolute;
    left: 50%;
    bottom: -5px;
    transform: translate3d(-50%, 0, 0);
    width: 90px;
    padding: 2px 5px;
    font-size: 12px;
    font-weight: normal;
    color: #fff;
    text-align: center;
    background: #F77696;
    border-radius: 15px;
    box-sizing: border-box;
}

.reservationMedicalCourseListItemDoctorImage {
    position: relative;
    top: -5px;
    overflow: hidden;
    width: 86px;
    min-width: 86px;
    height: 86px;
    border-radius: 50%;

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.reservationMedicalCourseListItemText {
    margin-left: 15px;

    @media screen and (max-width: 767px) {
        font-size: 15px;
    }

    .reservationMedicalCourseName {
        margin: 0 0 2px 4px;
        color: rgb(73	144	182	);
    }

    .reservationMedicalCourseHealthPackageIcon {
        position: relative;
        top: -4px;
        margin-bottom: 5px;

        img {
            width: 180px;
        }
    }

    .reservationMedicalCourseDescription {
        padding: 7px 11px;
        border-radius: 6px;
        background: rgb(246 248 253);
    }
}

.supportBanner {
    display: block;
    width: 100%;
    margin-top: 15px;
    text-align: center;
    transition: opacity 0.3s ease-in-out;

    &:hover {
        opacity: 0.7;
    }

    img {
        width: 100%;
        max-width: 480px;
        cursor: pointer;
    }
}

.btnTransQuestion {
    position: relative;
    width: 480px;
    margin-top: 20px;
    padding: 12px 45px 12px 20px;
    color: #fff;
    text-align: left;
    background: #F77696;
    border-radius: 10px;
    cursor: pointer;
    box-sizing: border-box;
    transition: opacity 0.2s ease-in-out;

    &::after {
        content: '';
        display: block;
        position: absolute;
        right: 30px;
        top: 50%;
        width: 15px;
        height: 15px;
        border: 3px solid;
        border-color: #fff #fff transparent transparent;
        transform: rotate(45deg) translateY(-50%);
        transition: right 0.2s ease-in-out;
    }

    &:hover {
        opacity: 0.7;

        &::after {
            right: 27px;
        }
    }

    .btnTransQuestionTitle {
        font-size: 20px;
        font-weight: bold;
    }

    .btnTransQuestionText {
        max-width: 290px;
        font-size: 14px;
    }
}
</style>
